'use strict'

import $ from 'jquery'

export default class Tables{
  constructor($el){
    this.$el = $($el)
    this.tooltip = this.$el.find('.tooltip__icon')
    this.close = this.$el.find('.tooltip__close')
    this.toggle = this.$el.find('.mobile-toggle')
    this.sectionSelector = this.$el.find('.tables__mobile__selector div')
    this.sectionSelectors = this.$el.find('.tables__mobile__selector div').toArray()
    this.mobileContent = this.$el.find('.tables__mobile__content')
    this.mobileCols = this.$el.find('.tables__mobile__columns .tables__mobile__column').toArray()

    if ($(this.$el.find('.tables__column')).hasClass('tables__column--featured')) {
      this.$el.find('.tables__column__header').addClass('featured-padding')
    }

    // Target first of Selector and Column arrays to make first of each "Active" on page load.
    $(this.sectionSelectors[0]).addClass('active-selector')
    $(this.mobileCols[0]).addClass('active')
    
    // Tooltip clicks
    this.tooltip.on('click', (e)=> {
      // Check to see if other Tooltips are open and close them
      this.$el.find('.tooltip-visible').removeClass('tooltip-visible').attr('aria-expanded', false)
      // Open current Tooltip
      $(e.currentTarget).parent().find('.tooltip__content').addClass('tooltip-visible').attr('aria-expanded', true)
    })

    // Close functionality
    this.close.on('click', (e)=> {      
      $(e.currentTarget).parent().removeClass('tooltip-visible').attr('aria-expanded', false)
    })

    // Mobile functionality
    this.toggle.on('click', (e)=> {
      e.preventDefault()
      // Check to see if mobile columns are displayed
      if (this.toggle.hasClass('open')) {
        // If so - Close tablesand change status text
        this.mobileContent.hide()
        this.toggle.removeClass('open')
        $(this.toggle).text('Show Features +')
      } else {
        // If not - Open table and change status text
        this.mobileContent.show()
        this.toggle.addClass('open')
        $(this.toggle).text('Hide Features -')
      }
    })

    this.sectionSelector.on('click', (e)=> {
      // Gates functionality to non-active seletors
      if (!$(e.currentTarget).hasClass('active-selector')) {
        // Set activeIndex to index of currently active selector
        let activeIndex = $(e.currentTarget).data('index')
        // Find active sibling and remove active status
        $(this.$el).find('.active').removeClass('active')
        // Fetch column with index value equal to activeIndex
        $(this.mobileCols[activeIndex]).addClass('active')
        $('.active-selector').removeClass('active-selector')
        // Set clicked selector as active selector
        $(e.currentTarget).addClass('active-selector')
      }
    })
  }
}
